import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { CoreQuestionsFactoryService, FormQuestionsService, ProfileService } from 'core/services';
import { QuestionBase, QuestionGroup, TextboxQuestion } from 'core/components/forms';
import { UntypedFormGroup } from '@angular/forms';

@Injectable()
export class MarsGroupConfigDocumentationQuestionsService implements FormQuestionsService {
  protected userRole;
  protected questions: QuestionBase<any>[];
  protected questionsSubject = new BehaviorSubject(null);
  protected formData: any = {};
  protected form: UntypedFormGroup;

  constructor(protected factory: CoreQuestionsFactoryService, public profileService: ProfileService) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  setForm(form: UntypedFormGroup) {
    this.form = form;
  }

  getFormData(): any {
    return null;
  }

  onDataChanged(newData: any = {}) {
    this.formData = newData;
  }

  getQuestionsObservable() {
    return this.questionsSubject.asObservable();
  }

  getFormQuestions(params: any = {}): Observable<QuestionBase<any>[]> {
    this.questions = [];
    this.onDataChanged();
    this.createQuestions(params);
    return this.getQuestionsObservable();
  }

  createQuestions(params: any = {}) {
    this.questions = [this.getDocumentationQuestions(params)];
    this.questionsSubject.next(this.questions);
  }

  getDocumentationQuestions(params) {
    const { group } = params;
    const childQuestions = [
      new TextboxQuestion({
        key: 'bookUrl',
        label: 'groups.config.documentation.bookUrl',
        class: 'col-1',
        value: group && group.documentation ? group.documentation.bookUrl : ''
      })
    ];

    const documentation = new QuestionGroup({
      title: 'groups.config.documentation.scopeLabel',
      isSection: true,
      childQuestions
    });

    return documentation;
  }
}
